import styled, { keyframes } from "styled-components";
import { rotatingShineAnimation } from "../../animations";

const scrollDiscounts = keyframes`
	0%, 22.222% {
		transform: translateY(0);
	}
	33.333%, 55.555% {
		transform: translateY(-1.0625em);
	}
	66.666%, 88.888% {
		transform: translateY(-2.125em);
	}
	100% {
		transform: translateY(-3.1875em);
	}
`;

export const Ribbon = styled.div<{ $left: number; $top: number }>`
	position: fixed;
	left: ${({ $left }) => `${$left}px`};
	top: ${({ $top }) => `${$top}px`};
	font-size: 10px;
	width: 9.8em;
	height: 2.9em;
	z-index: 10002;
	pointer-events: none;

	> svg {
		position: absolute;
		inset: 0;
		display: block;
		width: 100%;
		height: 100%;
		border-top-left-radius: 1.2em !important;
		z-index: 1;
	}
`;

export const RibbonShine = styled.img`
	position: absolute;
	top: 50%;
	left: 50%;
	width: 13.2em;
	height: 13.2em;
	opacity: 0.8;
	z-index: 0;
	${rotatingShineAnimation}
`;

export const RibbonContent = styled.div`
	position: absolute;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.25em;
	color: #fff;
	font-family: Baloo;
	font-size: 1.6em;
	line-height: 1.0625;
	text-transform: uppercase;
	transform: translateX(-0.3125em);
	z-index: 2;
`;

export const DiscountViewport = styled.div`
	width: 2.25em;
	height: 1.0625em;
	overflow: hidden;
`;

export const RibbonTicker = styled.div`
	width: 100%;
	animation: ${scrollDiscounts} 4s ease-in-out infinite;

	@media (prefers-reduced-motion: reduce) {
		animation: none;
	}
`;

export const Discount = styled.span`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	width: 100%;
	height: 1.0625em;
`;
